import React from "react";
import { Reactangle } from "./Reactangle";
import leftbar from "../../assets/images/leftbar.png";
import rightbar from "../../assets/images/rightbar.png";
import { HomeInfo, LeaderTalk } from "../../models/system";

import { updateVisitLeader } from "../../apis/api";
export class Oration extends React.Component {

    render(): React.ReactNode {


        let content = {} as LeaderTalk;

        if (window.sessionStorage.getItem("sysinfo") != null) {
            content = JSON.parse(window.sessionStorage.getItem("sysinfo")!);
        
        }

        if(window.sessionStorage.getItem("updateVisitLeader")==null){
            updateVisitLeader();
            window.sessionStorage.setItem("updateVisitLeader","1");
        }

        return (
            <>
                <div className="title"/>
                <div className="visitor">时间：{content.date}</div>
                <div className="viscount">浏览次数：{content.leaderHits!}</div>
                <div className="clear"></div>
                <hr className="hr1"></hr>
                <div className="h">馆长致辞</div>
                <div id="say" dangerouslySetInnerHTML={{ __html: content.content }}>

                </div>
                <div className="name">太仓博物馆馆长</div>
            </>
        )
    }
}